// extracted by mini-css-extract-plugin
export default {"registerContainer":"Register_registerContainer__sDB+p","registerBox":"Register_registerBox__2Tejz"};